import { connect } from "react-redux";
import FilterPanel from "./FilterPanel";
import {
  searchRoute,
  fetchSuggestions,
  clearSuggestions,
  updateRouteRequest,
} from "../../store/actions";

const mapStateToProps = state => ({
  routeRequest: state.routeRequest,
  suggestions: state.suggestions,
  restrictions: state.restrictions,
  calculations: state.calculations,
  routeNotFound: state.routeNotFound,
  isRouteSearching: state.isRouteSearching
});

const mapDispatchToProps = dispatch => ({
  /** @param {RouteRequest} routeRequest */
  updateRouteRequest: (routeRequest) => dispatch(updateRouteRequest(routeRequest)),
  searchRoute: params => dispatch(searchRoute(params)),
  fetchSuggestions: query => dispatch(fetchSuggestions(query)),
  clearSuggestions: () => dispatch(clearSuggestions())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FilterPanel);
